import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Publications from "./components/Publications";
import Projects from "./components/Projects";
import Certificates from "./components/Certificates";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    document.title = "Mohammad Rakibul Hasan Mahin";
    AOS.init();
  }, []);
  return (
    <div className='px-6 lg:px-20 xl:px-36 bg-black'>
      <Navbar />
      <Hero />
      <Education />
      <Skills />
      <Experience />
      <Publications />
      <Projects />
      <Certificates />
      <Footer />
    </div>
  );
}

export default App;
